import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminShortUrlsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('short-url');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
